import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getSelectedAccountNum } from "../../helpers/NavigationHelpers";
import { Transactions } from "./Transactions";

function TransactionsContainerComponent({ match, accounts, theme, history }) {
    const accountNum = getSelectedAccountNum(match.params.accountNum, accounts);

    return (
        <Transactions
            accounts={accounts}
            accountNum={accountNum}
            rangeId={match.params.rangeId}
            theme={theme}
            history={history}
        />
    );
}

TransactionsContainerComponent.propTypes = {
    accounts: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.shape({
        params: PropTypes.shape({
            accountNum: PropTypes.string,
            rangeId: PropTypes.string
        })
    }),
    theme: PropTypes.object
};

const mapStateToProps = state => ({
    accounts: state.accounts || {},
    theme: state.theme.selectedTheme
});

export const TransactionsContainer = connect(mapStateToProps)(TransactionsContainerComponent);
